import * as wheelEventsConf from 'OK/pms!wheelEventsConfig';

interface IWheelEventsConfiguration {
    wheelEventsPassive: boolean;
}

export function isWheelEventPassiveEnabled(): boolean {
    return (wheelEventsConf as IWheelEventsConfiguration).wheelEventsPassive;
}